import { ContentClass } from '../../Shared/enums';

/**
 * Whether conversational (AI) search is available for a given content class.
 * Video is always supported; audio and images are gated behind the
 * `showConversationalSearchAudio` and `showConversationalSearchImages` flags.
 */
export function isConversationalSearchEnabledForContentClass(
  contentClass: ContentClass | null,
  showConversationalSearchAudio: boolean,
  showConversationalSearchImages: boolean = false
): boolean {
  const supportedContentClasses = [ContentClass.Video];
  if (showConversationalSearchAudio) {
    supportedContentClasses.push(ContentClass.Audio);
  }
  if (showConversationalSearchImages) {
    supportedContentClasses.push(ContentClass.Image);
  }
  return contentClass != null && supportedContentClasses.includes(contentClass);
}
